import { FC } from "react"
import cx from "classnames"
import { MdOutlineKeyboardArrowRight } from "react-icons/md"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const ArrowRightIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <MdOutlineKeyboardArrowRight
      className={cx("w-5 h-5 active:scale-90", className)}
      {...rest}
    />
  )
}

export default ArrowRightIcon
